import React, { Component } from 'react';
import './styles/AppFrame.css';
import Topbar from './components/Topbar';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionSetRoutes } from "./actions";
import getRoutes from './services/routes';
import { Route, Redirect, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import SecurityManager from "./services/SecurityManager";


class AppFrame extends Component {

    static contextTypes = { api: PropTypes.object };

    constructor(props, context) {
        super(props);

        this.state = { routes: [], activeRoute: {}, initialized: false };

        context.api.me()
            .then(() => {
                const security = new SecurityManager(this.props.me);
                const routes = getRoutes(security);
                const activeRoute = AppFrame.routeFromArray(props.location.pathname, routes) || {};
                this.setState({ routes, activeRoute, initialized: true })
            })/*
            .catch((e) => {
                console.log('me error ' + e);
            });*/

    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        if (nextProps.location.pathname !== this.props.location.pathname) {
            this.setState({
                activeRoute: this.getRouteObject(nextProps.location.pathname) || {}
            });
        }
    }

    getRouteObject(path) {
        return AppFrame.routeFromArray(path, this.state.routes)
    }

    static routeFromArray(path, array) {
        for (let i = 0; i < array.length; i++) {
            const route = array[i];
            if (route.collapse) {
                const theRoute = this.routeFromArray(path, route.views);
                if (theRoute)
                    return theRoute;
            }
            else if (route.path.indexOf(':') !== -1) {
                const pathRoot = route.path.substr(0, route.path.indexOf(':'));
                if (pathRoot === path.substr(0, pathRoot.length))
                    return route;
            }
            else if (route.path === path)
                return route;

        }
    }

    render() {

        return (
            <div className="wrapper">

                <Sidebar
                    routes={this.state.routes}
                    location={this.props.location}
                    user={this.props.me}
                />

                <div className="main-panel">

                    <Topbar
                        route={this.state.activeRoute}
                    />

                    <div className="content">

                        {this.state.initialized ?

                            <TransitionGroup className='main-content-trans-group'>
                                <CSSTransition
                                    key={this.props.location.key}
                                    timeout={800}
                                    classNames='flip-main-container'>
                                    <Switch location={this.props.location} >
                                        {this.state.routes.map((route, i) => {
                                            if (route.collapse) {
                                                return route.views.map((prop, key) => {
                                                    return (
                                                        <Route exact={!(prop.exact === false)} path={prop.path}
                                                            component={prop.component} key={key} />
                                                    );
                                                })
                                            }
                                            if (route.redirect)
                                                return <Redirect path={route.path} from={route.path} to={route.to} component={route.component} key={i} />
                                            else
                                                return (
                                                    <Route exact={!(route.exact === false)} path={route.path} component={route.component} key={i} />
                                                );
                                        })}
                                        

                                    </Switch>
                                </CSSTransition>
                            </TransitionGroup> : null}

                    </div>

                    <Footer />

                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {

    return bindActionCreators({
        setRoutes: actionSetRoutes
    }, dispatch);

}

function mapStateToProps({ api: { me } }) {
    return { me };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppFrame);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/index.jsx